
import 'core-js/es6/map';
import 'core-js/es6/set';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app';

require('./style.less');

ReactDOM.render(<App />, document.getElementById('root'));